import * as types from "../types";
import { initAuth } from "~services/auth";
import { authority } from "~api";
import state from "./state";

const {
  apiGetCrmRole,
  apiGetCrmAuthorityMenu,
  apiUpdateOperate,
  apiUpdateData,
  apiGetAuthority,
  apiGetTeamList,
  apiGetUserInfo,
} = authority;

export default {
  getCrmRole({ commit }, payload) {
    return apiGetCrmRole(payload).then(res => {
      if (res.data && res.data.data) {
        commit(types.GET_CRM_ROLE, res.data.data);
      }
    });
  },

  getCrmAuthorityMenu({ commit }, payload) {
    return apiGetCrmAuthorityMenu(payload).then(res => {
      if (res.data && res.data.data) {
        if (payload.menuType === 1) {
          commit(types.GET_CRM_OPERATION_MENU, res.data.data);
        }
        if (payload.menuType === 2) {
          commit(types.GET_CRM_DATA_MENU, res.data.data);
        }
      }
    });
  },
  updateOperate({ commit }, payload) {
    return apiUpdateOperate(payload);
  },

  updateData({ commit }, payload) {
    return apiUpdateData(payload);
  },

  getUserInfo({ commit }, payload) {
    if (Object.keys(state.userInfo).length === 0) {
      return apiGetUserInfo(payload).then(res => {
        if (res.data) {
          commit(types.GET_USERINFO, res.data);
        }
      });
    }
    return true;
  },

  // 获取用户权限信息
  getAuthority({ commit }, payload) {
    return apiGetAuthority(payload).then(res => {
      console.log("获取权限咯", payload);
      if (res.data) {
        // 保存登录状态
        commit(types.AUTHENTICATED, true);

        // 存储后端返回的原始权限信息
        // auth = res.data.roleData;
        // commit(types.GET_AUTHORITY, auth);

        // 简化权限数据结构并保存
        // auth = initAuth(res.data.roleData);
        // const auth = res.data.data.map(item => ({
        //   [item.code.match('[^/]+(?!.*/)')[0]]: item,
        // }))
        const { menuUrl } = payload;
        const { data } = res.data;
        const auth = Object.assign(
          {},
          ...data.map(item => ({ [item.code.match("[^/]+(?!.*/)")[0]]: item })),
        );
        switch (menuUrl) {
          case "/quickAdd":
            commit(types.GET_QUICK_ADD_AUTH, auth);
            break;
          case "/customer/valid":
            commit(types.GET_CUSTOM_AUTH, auth);
            break;
          case "/medicalCus/vaild":
            commit(types.GET_MEDICALCUSTOM_AUTH, auth);
            break;
          case "/backstage/productManage":
            commit(types.GET_PRODUCT_MANAGE_AUTH, auth);
            break;
          case "/visit":
            commit(types.GET_VISIT_AUTH, auth);
            break;
          case "/compact/contract":
            commit(types.GET_CONTRACT_AUTH, auth);
            break;
          case "/business/opportunity":
            commit(types.GET_BUSINESS_AUTH, auth);
            break;
          default:
            commit(types.GET_AUTHORITY, auth);
            break;
        }
      }
    });
  },
  getTeamList({ commit }, payload) {
    return apiGetTeamList(payload).then(res => {
      if (res.data && res.data.data) {
        commit(types.GET_CRM_TEAM_LIST, res.data.data);
      }
    });
  },
};
